module.exports = __webpack_public_path__ + "static/media/bulb.bfa52474.svg";